import {useState} from "../../../__snowpack__/pkg/react.js";
import {createModel} from "../../../__snowpack__/pkg/hox.js";
import {axios} from "../../lib/axios.js";
import {handleError} from "../../lib/errorHandler.js";
import queryString from "../../../__snowpack__/pkg/query-string.js";
export const useStaffs = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const fetchData = async (pageInfo, query) => {
    setLoading(true);
    try {
      const {
        data: {
          content,
          number: page,
          size: pageSize,
          totalElements: pageTotal
        }
      } = await axios.post(`/saas/member/v1/users/_search?${queryString.stringify({
        page: pageInfo && pageInfo.page && pageInfo.page - 1,
        size: pageInfo && pageInfo.pageSize
      })}`, {
        ...query
      });
      setData(content);
      return {
        staffs: content,
        staffsPageInfo: {
          page: page + 1,
          pageSize,
          pageTotal
        }
      };
    } catch (error) {
      handleError(error);
      return {
        staffs: data,
        staffsPageInfo: pageInfo
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    staffsLoading: loading,
    staffs: data,
    fetchStaffs: fetchData
  };
};
export const useStaffsModel = createModel(useStaffs);
export const useStaff = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async (id) => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get(`/saas/member/v1/users/${id}`);
      setData(data2);
      return {
        staff: data2
      };
    } catch (error) {
      handleError(error);
      return {
        staff: data
      };
    } finally {
      setLoading(false);
    }
  };
  return {
    staffLoading: loading,
    staff: data,
    fetchStaff: fetchData
  };
};
export const useStaffModel = createModel(useStaff);
export const useLimitProcess = () => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const fetchData = async (params) => {
    setLoading(true);
    try {
      const dataInfo = await axios.post(`/saas/resource/limit/process`, params);
      setData(dataInfo);
      return dataInfo;
    } catch (error) {
      handleError(error);
      return data;
    } finally {
      setLoading(false);
    }
  };
  return {
    processLoading: loading,
    process: data,
    fetchProcess: fetchData
  };
};
export const useLimitProcessModel = createModel(useLimitProcess);
export const useControlDetail = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const fetchData = async () => {
    setLoading(true);
    try {
      const {data: data2} = await axios.get(`/saas/resource/limit/control-detail`);
      setData(data2);
      return data2;
    } catch (error) {
      handleError(error);
      return data;
    } finally {
      setLoading(false);
    }
  };
  return {
    controlDetailLoading: loading,
    controlDetail: data,
    fetchControlDetail: fetchData
  };
};
export const useControlDetailModel = createModel(useControlDetail);
